var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalWizard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 70",
    style: {
      enableBackground: "new 0 0 102 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#E6E6E6;}\r\n\t.st1{fill:none;stroke:#E6E6E6;}\r\n\t.st2{fill:none;stroke:#E6E6E6;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;stroke:#DADADA;stroke-miterlimit:10;}\r\n\t.st5{fill:#E6E6E6;}\r\n\t.st6{fill:none;stroke:#0072C6;stroke-width:2;}\r\n\t.st7{fill:#0072C6;stroke:#0072C6;stroke-miterlimit:10;}\r\n\t.st8{fill:#E6E6E6;stroke:#E6E6E6;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st9{fill:#0072C6;}\r\n\t.st10{fill:none;stroke:#0072C6;}\r\n\t.st11{fill:#E5E1DF;}\r\n\t.st12{fill:#F15A24;}\r\n\t.st13{fill:none;stroke:#F15A24;}\r\n\t.st14{opacity:0.6;fill:none;stroke:#D3D3D3;}\r\n\t.st15{fill:#D3D3D3;}\r\n\t.st16{fill:#616160;}\r\n\t.st17{fill:none;stroke:#616160;}\r\n\t.st18{fill:#FFFFFF;stroke:#DADADA;stroke-miterlimit:10;}\r\n\t.st19{opacity:0.5;}\r\n\t.st20{fill:none;stroke:#0072C6;stroke-miterlimit:10;}\r\n\t.st21{fill:none;stroke:#D3D3D3;}\r\n\t.st22{fill:none;stroke:#C4C4C4;stroke-width:0.5;}\r\n\t.st23{fill:#C4C4C4;}\r\n\t.st24{fill:none;stroke:#C4C4C4;stroke-width:2;}\r\n\t.st25{fill:#C5C4C4;}\r\n\t.st26{fill:none;}\r\n\t.st27{fill:#FFFFFF;stroke:#C4C4C4;stroke-miterlimit:10;}\r\n\t.st28{opacity:0.6;}\r\n\t.st29{fill:#006837;}\r\n\t.st30{opacity:0.6;fill:none;stroke:#D3D3D3;enable-background:new    ;}\r\n\t.st31{opacity:0.5;fill:#D3D3D3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_60134-2_00000048499273354290478180000011230838911852674965_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2774-2_00000120544102147230002180000009390367521722430374_",
    className: "st30",
    x1: 14.8524,
    y1: 30.5489,
    x2: 14.8524,
    y2: 39.4559
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2775-2_00000109733209754497091790000014779673883292153023_",
    className: "st30",
    x1: 14.8524,
    y1: 46.9739,
    x2: 14.8524,
    y2: 55.8809
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3311-2_00000028307899660220796640000004411252186490583686_",
    transform: "translate(12.523 6.284)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 2.3294,
    cy: 3.9929,
    r: 4.425
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 2.3294,
    cy: 3.9929,
    r: 3.925
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3312-2_00000181774371552666649780000001009969535215892148_",
    transform: "translate(12.523 22.651)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 2.3294,
    cy: 3.9929,
    r: 4.425
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 2.3294,
    cy: 3.9929,
    r: 3.925
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3313-2_00000003064504275403662050000008436771264562530969_",
    transform: "translate(12.523 39.019)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 2.3294,
    cy: 3.9929,
    r: 4.425
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 2.3294,
    cy: 3.9929,
    r: 3.925
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3314-2_00000172436781851468211870000006663446923179263652_",
    transform: "translate(12.523 55.387)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 2.3294,
    cy: 3.9929,
    r: 4.425
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 2.3294,
    cy: 3.9929,
    r: 3.925
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2776-2_00000051383613653872619540000006221054519298428567_",
    className: "st17",
    x1: 14.8524,
    y1: 14.7019,
    x2: 14.8524,
    y2: 22.2189
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.1797,
    y: 8.8554,
    className: "st31",
    width: 62.4719,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.1797,
    y: 24.9453,
    className: "st31",
    width: 62.4719,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9551,
    y: 41.0351,
    className: "st31",
    width: 62.4719,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.1797,
    y: 57.125,
    className: "st31",
    width: 62.4719,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalWizard1);
export default __webpack_public_path__ + "static/media/VerticalWizard1.73300039acaffa05a5dfabcd2e3f939b.svg";
export { ForwardRef as ReactComponent };